import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { PIN_MINIMUM_FOUR_MAXIMUM_FOUR_CHARACTERS_ONLY_NUMBERS, pinMatchingValidator } from '@shared/feature/forms';
import { InputDisplay, InputFieldType } from '@shared/ui/inputs';
import { EditProfileService } from '../../services/edit-profile.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'sh-shared-layout-change-pin-dialog',
  templateUrl: './change-pin-dialog.component.html',
  styleUrls: ['./change-pin-dialog.component.css'],
  standalone: false,
})
export class ChangePinDialogComponent implements OnInit {
  pinForm: FormGroup;
  inputType = InputFieldType.Password;
  inputFieldDisplay = InputDisplay.Inline;

  officerUid?: string;

  constructor(public service: EditProfileService, public ref: DynamicDialogRef, public config: DynamicDialogConfig) {
    this.pinForm = new FormGroup(
      {
        pin: new FormControl('', [
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(4),
          Validators.pattern(PIN_MINIMUM_FOUR_MAXIMUM_FOUR_CHARACTERS_ONLY_NUMBERS),
        ]),
        confirmPin: new FormControl('', [
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(4),
          Validators.pattern(PIN_MINIMUM_FOUR_MAXIMUM_FOUR_CHARACTERS_ONLY_NUMBERS),
        ]),
      },
      { validators: pinMatchingValidator() }
    );
  }

  ngOnInit(): void {
    this.officerUid = this.config.data?.officerUid;
  }

  onChangeClick(): void {
    this.service.changeLoggedInOfficerPin(this.pinForm.value.pin, this.officerUid);
    this.ref.close();
  }
}
